import { Tooltip } from '@mui/material'

const TextOverflowLine = ({ children, className, placement = 'top', id, style, lines = 2 }) => {
  return (
    <Tooltip arrow title={children || ''} placement={placement} key={`text-ellipsis-${id}`}>
      <div className={`text-overflow-${lines}-lines  ${className}`} style={style}>
        {children}
      </div>
    </Tooltip>
    
  )
}

export default TextOverflowLine